import { useQuery } from "../data/useQuery.js";
import { useBoundQuery, FillPrompt } from "../data/DwSql.js";
import type { VizProps } from "./registry.js";
import { ResultTable } from "./ResultTable.js";

export function QueryViz({ source, attrs }: VizProps) {
  const trimmed = source.trim();
  // Nothing to run once line comments are stripped (e.g. a fresh query file
  // that's just `-- Enter Sql here`). Don't fire a query for that.
  const empty = trimmed.replace(/--.*$/gm, "").trim().length === 0;
  const { sql, values, path, status, missing } = useBoundQuery(trimmed);
  // Hold the query when empty or blocked (null sql) so it never runs unbound.
  const q = useQuery(!empty && status === "ready" ? sql : null, {
    // Explicit attr overrides the query's @maxAge pragma; absent → pragma →
    // forever (useQuery sends maxAgeDefault).
    ttl: attrs.maxAge ?? attrs.ttl,
    values,
    path,
  });
  return (
    <div className="dw-embed dw-embed-query">
      {empty && <div className="dw-loading">Write a query to see results.</div>}
      {!empty && status === "blocked" && <FillPrompt names={missing} />}
      {!empty && status === "ready" && q.status === "loading" && (
        <div className="dw-loading">Running…</div>
      )}
      {!empty && status === "ready" && q.status === "error" && (
        <pre className="dw-error">{q.error.message}</pre>
      )}
      {!empty && status === "ready" && q.status === "ready" && (
        <ResultTable result={q.data} format={attrs.format} />
      )}
    </div>
  );
}
